import React, { useEffect } from 'react';
import { PlanPickerManagerComponent } from './PlanPickerManagerComponent';
import { useData } from '../../../data-layer';

export function PlanPickerManager(): React.ReactElement {
  const { planPicker, plans } = useData();

  // Plans back the SKU selection on PlanPickerForm.
  useEffect(() => {
    planPicker.hook.getAll();
    plans.hook.getAll();
  }, []);

  return <PlanPickerManagerComponent />;
}
